import { fetch } from 'utils/fetch';

/**
 * 获取所有部门
 * @param roleType 无用
 * @param userOID
 * @returns {*}
 */
export const getAllDepartment = (companyOID, applicantOID, keyword) => {
  let params = {
    status: 101, // 101表示启用
  };
  companyOID && (params.companyOID = companyOID);
  applicantOID && (params.applicantOID = applicantOID);
  keyword && (params.keyword = keyword);
  return fetch({
    url: '/api/department/tenant/all',
    method: 'GET',
    params,
  });
};

/**
 *
 * @returns {Promise<Response>}
 */
export const getAllDepartmentV2 = () => {
  return fetch({
    url: '/api/departments/root/v2?flag=1001',
    method: 'GET',
  });
};

/**
 * 获取所有部门，本接口只返回userCount和path
 * @returns {*}
 */
export const getAllDepartmentSimplify = () => {
  return fetch({
    url: 'api/department/tenant/allnumber',
    method: 'GET',
  });
};

export const getDepartmentGroup = (page, size, keyword) => {
  return fetch({
    url: `/api/DepartmentGroup/selectDept/enabled?&name=${keyword}&nameLable=${keyword}&page=${page}&size=${size}`,
    method: 'GET',
  });
};

/**
 * 获取指定部门的信息
 * @param departmentOID
 * @returns {*}
 */
export const getDepartment = (departmentOID) => {
  return fetch({
    url: `/api/departments/${departmentOID}`,
    method: 'GET',
  });
};
